<template>
  <section class="container-fluid">
    <h3 class="h3 mb-4 text-gray-800">Blank Page</h3>
  </section>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Blank'
})
</script>